import React from "react";
import {
    Table,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    TableHead,
} from "@mui/material";

const SafetyChartTable = ({
    title,
    tableData,
    headerDateColumns,
    TRIRValue,
    LTIRValue,
}) => {
    const colors = [
        "#f92424",
        "#986800",
        "#ffcc01",
        "#ffff00",
        "#00ff00",
        "#fe9a01",
        "#95b5dd",
    ];
    const tableCellStyle = (rowIndex) => ({
        px: 0,
        py: "9px",
        textAlign: "center",
        bgcolor:
            rowIndex >= 0 && rowIndex < colors.length
                ? colors[rowIndex]
                : "transparent",
    });
    const tableHeaderStyle = {
        px: 0,
        py: 1,
        bgcolor: "#fff",
        textAlign: "center",
        borderRight: "1px solid #e0e0e0",
    };

    const renderRemainingRows = (data) =>
        data?.map((item, index) => (
            <TableRow key={index}>
                {headerDateColumns?.map((_, colIndex) => (
                    <TableCell colSpan={1} key={colIndex} sx={tableCellStyle(index)}>
                        {item[`headerDate${colIndex}`] ?? "-"}
                    </TableCell>
                ))}
            </TableRow>
        ));

    return (
        <TableContainer component={Paper} sx={{ height: "100%" }}>
            <Table sx={{ tableLayout: "fixed", width: "100%", height: "100%" }}>
                <TableHead>
                    <TableRow>
                        <TableCell
                            colSpan={headerDateColumns?.length}
                            sx={{
                                ...tableHeaderStyle,
                                borderRight: "1px solid #e0e0e0",
                                borderBottom: "none",
                            }}
                        >
                            {title ? "Overall Safety Performance" : ""}
                        </TableCell>
                        {headerDateColumns?.map((header, index) => (
                            <TableCell
                                colSpan={1}
                                key={index}
                                sx={{ ...tableHeaderStyle, whiteSpace: "pre-wrap" }}
                            >
                                {header}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell
                            rowSpan={8}
                            colSpan={headerDateColumns?.length}
                            sx={{
                                ...tableCellStyle,
                                borderRight: "1px solid #e0e0e0",
                                p: 0,
                                position: "relative",
                            }}
                        >
                            <img
                                src="assets/illustrations/funnel.svg"
                                alt="funnel"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "fill",
                                    position: "absolute",
                                    bottom: 0,
                                    right: 0,
                                }}
                            />
                        </TableCell>
                    </TableRow>
                    {renderRemainingRows(tableData)}
                    <TableRow>
                        <TableCell colSpan={headerDateColumns?.length} sx={tableCellStyle}>
                            TRIR (12 months rolling average)
                        </TableCell>
                        <TableCell colSpan={headerDateColumns?.length} sx={tableCellStyle}>
                            {TRIRValue}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={headerDateColumns?.length} sx={tableCellStyle}>
                            LTIR (12 months rolling average)
                        </TableCell>
                        <TableCell colSpan={headerDateColumns?.length} sx={tableCellStyle}>
                            {LTIRValue}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default SafetyChartTable;
